module.exports = __webpack_public_path__ + "img/icons B_27.e429562c.svg";